if (typeof window.SectionPushImage === 'undefined') {
  class SectionPushImage {
    constructor(splideContainer) {
      this.splideContainer = splideContainer;
      this.splideInstance = undefined;
      this.init();
  }

  init() {
    if (!this.splideContainer || typeof window.Splide === 'undefined') return;
    this.enableSplide();
  }

  enableSplide() {
    if (!this.splideInstance) {
      this.splideInstance = new window.Splide(this.splideContainer, {
        type: 'slide',
        autoWidth: true,
        gap: '1rem',
        pagination: true,
        arrows: false,
        duration: 1500,
        dragMinThreshold: 5,
        flickPower: 100,
        mediaQuery: 'min',
        breakpoints: {
          1024: {
            destroy: true,
          },
        }
      }).mount();
    }
  }
}

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.js-push-image-splide').forEach(function(splide) {
      new SectionPushImage(splide);
    });
  });
}
